module.exports = __webpack_public_path__ + "img/pinterest.e0b04945.svg";